import { gql } from '@apollo/client'

export const KUSTOMER_CREATE_CONVERSATION = gql`
  query kustomerCreateConversation(
    $email: String!
    $fullName: String!
    $subject: String!
    $message: String!
  ) {
    kustomerCreateConversation(
      email: $email
      fullName: $fullName
      subject: $subject
      message: $message
    ) {
      success
    }
  }
`
